<template>
  <myhead @next="next" @lookmore="more">{{ $route.query.title || $route.meta.title}}</myhead>
  <div class="myField2 mb50" style="padding-bottom:20px" v-if="detail">
    <div v-for="item,index in detail.question" :key="index">
      <van-field v-model="item.answer" v-if="0==item.is_textarea" :label="item.name+':'" placeholder="请填写" />
      <div class="ml15 mr15 mt5" v-else>
        <div v-if="index == 0">
          <p class="mb15"> {{item.name}}</p>
          <van-radio-group v-model="checked" direction="horizontal">
          <van-radio name="1" >接受</van-radio>
          <van-radio name="0">拒绝</van-radio>
        </van-radio-group>
        </div>
        <div v-else>
          {{item.name}}
          <van-field type="textarea" placeholder="请填写" class="BGf5 Cccc pad15 mt20 mb30 radius8" v-model="item.answer" rows="2" autosize />
        </div>
     </div>
    </div>
  </div>
  <div class="pad15 fixed l r b gray">
    <!-- <van-button type="primary" round block> -->
    <div class="button size16">
      <div class="mr15">
        <input style="background-color:#3f7c93" class="width100px" v-model="num" type="number" :placeholder="$route.query.cate_id == 1 ? '请输入商品成本' : ($route.query.cate_id == 2 ? '请输入本人年龄' : '请输入人民数量') " >
      </div>
      <div v-if="!num" @click="hint">审核费用待定</div>
      <div @click="next" v-else>￥{{Amount}} 支付审核费用</div>

    </div>

    <!-- </van-button> -->
  </div>
  <PayDialog v-model:showPopup="playAlery" title="审核费用" :amount="Amount||0" :nextFn="next"></PayDialog>
</template>

<script>
import PayDialog from "@/components/PayDialog.vue";
import { showToast,showConfirmDialog} from 'vant'
export default {
  name: 'Home', components: { PayDialog },
  data () {
    return {
      info:'',
      checked:"1",
      detail: null,
      playAlery: false,
      amount:0,
      num: ''// 用户输入参考数据
    }
  },
  computed: {
    Amount () {
      return (this.num * this.amount).toFixed(2)
    }
  },
  watch:{
    checked:function(newVal){
      if(newVal == "0"){
        this.dialog()
      }
    }
  },
  methods: {
    dialog(){
      showConfirmDialog({
        message: this.info,
        confirmButtonText:"接受",
        cancelButtonText:"拒绝"
      }).then(() => {
        this.checked = "1"
      }).catch(()=>{
        this.$router.go(-1)
      });
    },
    // 提示
    hint () {
      showToast('请填写输入框内容')
    },
    more () {
      console.log("更多")
    },
    next (amount, typeid) {
      if (this.playAlery) {
        this.ajax({
          method: "post", url: "pay/pay", data: {
            typeid, no: this.no,
            return_url: location.origin + "/#/join?active=" + (this.$route.query.cate_id - 1)
          }, myData: { showMsg: false }
        }).catch(({ message }) => {
          if (amount == 0) {
            return this.$router.replace({ path: '/join', query: { active: this.$route.query.cate_id - 1 } })
          } else {
            this.showNotify({ message })
          }
        }).then(({ data }) => {
          if (typeid == 1) {
            // this.$router.replace({path:'/sense/status',query:{no:this.no}})
            location.href = data.info;
          } else {
            //开发中
          }
        })
      } else {
        this.detail.question[0].answer = this.checked
        this.ajax.post("joins/join", { ...this.$route.query, question: JSON.stringify(this.detail.question) }).then(({ data }) => {
          this.playAlery = true;
          this.no = data.no;
        })
      }
    }
  },
  created () {
    this.ajax.post("joins/getquestion", { ...this.$route.query }).then(({ data }) => {
      data.question.map(item => { item.answer = '' })
      this.detail = data;
      this.info = data.question[0].name;
      this.amount = this.detail.total_amount;
      this.$nextTick(()=>{
        this.dialog()
      })
    })
   
  }
}
</script>

<style>

.button{
  display: flex;
  background-color: #3f7c93;
  color: #fff;
  padding: 10px;
  border-radius: 30px;
  
}


</style>
